import { Mail, MapPin, Phone } from 'lucide-react';
import { contactDetails } from '../data/contactInfo';

/**
 * Left-hand column of the contact page. Renders phone, address, office email
 * and support email cards. All data comes from /data/contactInfo.js.
 */
export function ContactInfoPanel({ language }) {
  const isDe = language === 'de';
  const { phone, address, email, supportEmail } = contactDetails;

  return (
    <div className="space-y-6 mb-12">
      {/* Phone */}
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 bg-[#2E5E99]/10 rounded-xl flex items-center justify-center flex-shrink-0">
          <Phone className="w-6 h-6 text-[#2E5E99]" />
        </div>
        <div>
          <div className="font-semibold text-[#0D2440] mb-1">
            {isDe ? 'Telefon' : 'Phone'}
          </div>
          <a href={phone.href} className="text-[#2E5E99] hover:underline">
            {phone.display}
          </a>
          <div className="text-sm text-[#5A7A9B] mt-1">
            {isDe ? phone.hoursDe : phone.hoursEn}
          </div>
        </div>
      </div>

      {/* Address */}
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 bg-[#2E5E99]/10 rounded-xl flex items-center justify-center flex-shrink-0">
          <MapPin className="w-6 h-6 text-[#2E5E99]" />
        </div>
        <div>
          <div className="font-semibold text-[#0D2440] mb-1">
            {isDe ? 'Adresse' : 'Address'}
          </div>
          <a
            href={address.mapsHref}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#5A7A9B] hover:text-[#2E5E99]"
          >
            {address.street}<br />
            {address.city}<br />
            {isDe ? address.countryDe : address.countryEn}
          </a>
        </div>
      </div>

      {/* Email */}
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 bg-[#2E5E99]/10 rounded-xl flex items-center justify-center flex-shrink-0">
          <Mail className="w-6 h-6 text-[#2E5E99]" />
        </div>
        <div>
          <div className="font-semibold text-[#0D2440] mb-1">Email</div>
          <a href={`mailto:${email}`} className="text-[#2E5E99] hover:underline block">
            {email}
          </a>
        </div>
      </div>

      {/* Support Email */}
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 bg-[#2E5E99]/10 rounded-xl flex items-center justify-center flex-shrink-0">
          <Mail className="w-6 h-6 text-[#2E5E99]" />
        </div>
        <div>
          <div className="font-semibold text-[#0D2440] mb-1">Support</div>
          <a href={`mailto:${supportEmail}`} className="text-[#2E5E99] hover:underline block">
            {supportEmail}
          </a>
        </div>
      </div>
    </div>
  );
}
